<template>
  <div class="staff-page">
    <ul>
      <li><router-link to="/yanfei">Yanfei Liu</router-link></li>
    </ul>
  </div>
</template>

<style>
.staff-page {
  /* Add styles for the staff page */
}
</style>